import { observable, autorun } from 'mobx'

class Store {
    locations = observable([])
    map_center = observable({
        lat: 32, lng: 35
    })
}

const store = new Store()

autorun(() => {
    console.log('lat', store.map_center.lat)
    console.log('lng', store.map_center.lng)
    console.log('zoom', store.map_center.zoom)
})

export default store